import * as React from 'react';
import {createStyles, Theme} from "@material-ui/core";
import {buttonContainedLarge, styleColors} from "src/main.style";

export const ecoContainerStyle = (theme: Theme) =>
    createStyles({
        buttonContainedLarge,
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            gap: '30px',

            [theme.breakpoints.up("md")]: {
                flexDirection: 'row',
                flexWrap: 'wrap',
            },
        },
        titleWrapper: {
            flex: '1 1 100%',
        },
        badge: {
            backgroundColor: theme.palette.primary.main,
            color: styleColors.white,
            padding: '1px',
            borderRadius: '9999px',
            minWidth: '16px',
            fontSize: '12px',
            textAlign: 'center',
            marginLeft: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 400,
            fontFamily: 'Metropolis',
        },
        parentWithTraillingText: {
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        traillingTittle: {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        heading1: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '16px',
            color: styleColors.black,
        },
        body1: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '18px',
            // display: 'flex',
            alignItems: 'center',
            color: styleColors.black,
        },
        body2: {
            fontFamily: 'Metropolis',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '9px',
            lineHeight: '13px',
            display: 'flex',
            alignItems: 'center',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            color: styleColors.warmGrey,
        },
        card: {
            padding: '10px 20px',
            background: styleColors.white,
            border: `1px solid ${styleColors.blackAlpha23}`,
            boxShadow: `0px 4px 4px ${styleColors.blackAlpha23}`,
            borderRadius: '14px',
            display: 'flex',
            flexDirection: 'column',

            [theme.breakpoints.up("sm")]: {
                maxWidth:'320px',
                minWidth:'320px',
            },
        },
        tooltip : {
            minWidth:200, 
            maxWidth:280,
            top:'40px',
            right: '-30px',
            padding:'10px 20px',
            color:styleColors.greyLight2,
            backgroundColor:styleColors.greyDark3,
            fontSize:'13px',
            borderRadius:'8px',
            position:'absolute',
            zIndex: theme.zIndex.tooltip,
            boxSizing:'border-box',
            border:`1px solid ${styleColors.black}`,
            boxShadow:`0 1px 8px ${styleColors.blackAlpha45}`,
            "&:after": {
                right: '46px',
                top: '-7px',
                width: '12px',
                boxShadow: `0 1px 8px ${styleColors.blackAlpha45}`,
                height: '12px',
                content: "''",
                position: 'absolute',
                transform: 'rotate(45deg)',
                backgroundColor: styleColors.greyDark3,
            }
        },
        monthHeader: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '15px',
            fontWeight: 700,
            lineHeight: '15px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
        },
        balanceTitle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: '1px',
            padding: '5px 0px',
        },
        cardContent: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '5px 0 5px 0px',
            borderBottom: `1px solid ${styleColors.warmGrey}`,
            marginBottom: '5px',
            transition: 'all 0.4s',
            '&:last-child': {
                borderBottom: 'none',
                marginBottom: 0,
            },
        },
        cardContentListItem: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            maxWidth: 'calc(100vw - 140px)',
        },
        itemTopRow: {
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: '8px',
            // alignItems: 'center',
        },
        itemBottomRow: {
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'space-between',
        },
        splitAgreement: {
          display: 'flex',
          flexDirection: 'row',
            gap: '4px',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        splitAgreementItem: {
            display: 'flex',
            flexDirection: 'row',
            gap: '4px',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
        },
        swish:{
            maxWidth: 24,
            maxHeight: 24,
        },
        venmo:{
            maxWidth: 24,
            maxHeight: 24,
        },
        cashapp:{
            maxWidth: 24,
            maxHeight: 24,
        },
        paypal:{
            maxWidth: 24,
            maxHeight: 24,
        }
        ,
        helpText : {
            color: styleColors.greyMedium1, 
            fontSize: '17px',  
            textShadow: `0px 1px 0px ${styleColors.whiteOverlay28}, 0px -1px 0px ${styleColors.blackInset33}`
        }
    });



// WEBPACK FOOTER //
// ./src/components/economy/Container.style.ts